import React, { forwardRef, type FC, type PropsWithoutRef } from 'react';

import { container } from './container';

// This HOC is used to override a component top-level, using Inversify
// More info: platforms/web/src/modules/register.ts
const createInjectableComponent = <Props extends object>(identifier: symbol, DefaultComponent: FC<PropsWithoutRef<Props>>) => {
  return forwardRef<unknown, Props>((props, ref) => {
    const isOverridden = container.isBound(identifier);

    if (isOverridden) {
      const OverriddenComponent = container.get<FC<PropsWithoutRef<Props>>>(identifier);

      return <OverriddenComponent {...props} ref={ref} />;
    }

    return <DefaultComponent {...props} ref={ref} />;
  });
};

export default createInjectableComponent;
